module.exports = __webpack_public_path__ + "img/cb2-r-y1.191bd3c1.gif";